// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__0t7MF","container":"main_container__ixvRS"};